export interface LanguageDescriptionModel {
  nativeLabel: string;
  localizedLabel: string;
  code: string;
  icon: string;
}
